import { t } from 'i18next';

type OfferLike = {
  name?: string;
  price_formatted?: string;
  payment_type?: string | null;
  recurring_interval?: string | null;
};

export function recurringIntervalSuffix(
  paymentType?: string | null,
  interval?: string | null,
): string {
  const isRecurring = paymentType === 'recurring' || Boolean(interval);

  if (!isRecurring || !interval) {
    return '';
  }

  const key = `common:recurringIntervals.${interval}`;
  const translated = t(key);

  if (!translated || translated === key) {
    return '';
  }

  return translated.startsWith(' ') ? translated : ` ${translated}`;
}

export function formatOfferOptionLabel(offer: OfferLike): string {
  const name = offer.name?.trim() ?? '';
  const price = offer.price_formatted?.trim() ?? '';
  const suffix = recurringIntervalSuffix(
    offer.payment_type,
    offer.recurring_interval,
  );
  const priceWithInterval = `${price}${suffix}`;

  if (name && priceWithInterval) {
    return `${name} - ${priceWithInterval}`;
  }

  return name || priceWithInterval;
}
